define(["require", "exports", "tslib", "@material-ui/core/Collapse", "@material-ui/core/IconButton", "@material-ui/core/styles", "@material-ui/icons/ExpandMore", "react", "../../utils/MathUtil", "./HGroup", "./Tooltip"], function (require, exports, tslib_1, Collapse_1, IconButton_1, styles_1, ExpandMore_1, React, MathUtil_1, HGroup_1, Tooltip_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FormNoCollapse = exports.FormCollapseHeader = exports.FormCollapse = void 0;
    Collapse_1 = tslib_1.__importDefault(Collapse_1);
    IconButton_1 = tslib_1.__importDefault(IconButton_1);
    ExpandMore_1 = tslib_1.__importDefault(ExpandMore_1);
    React = tslib_1.__importStar(React);
    Tooltip_1 = tslib_1.__importDefault(Tooltip_1);
    const useStyles = (0, styles_1.makeStyles)((theme) => ({
        root: {
            width: "100%",
            marginBottom: 10
        },
        header: {
            justifyContent: "space-between",
            borderBottom: '1px solid #EEE',
            padding: '0px 20px',
            background: 'white',
            marginTop: '10px',
            borderRadius: '10px 10px 0 0',
            fontWeight: 500,
            cursor: 'pointer',
            alignItems: 'center',
            minHeight: "60px"
        },
        headerCollapsed: {
            borderRadius: "10px"
        },
        media: {
            height: 0,
            paddingTop: '56.25%',
        },
        expand: {
            transform: 'rotate(0deg)',
            marginLeft: 'auto',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shortest,
            }),
        },
        expandOpen: {
            transform: 'rotate(180deg)',
        },
    }));
    function FormCollapse(props) {
        const { header, headerClass, children, open } = props;
        const classes = useStyles({});
        const [expanded, setExpanded] = React.useState(!!open);
        const toggle = () => {
            setExpanded(!expanded);
        };
        return React.createElement("div", { className: classes.root },
            React.createElement(HGroup_1.HGroup, { onClick: toggle, className: `${headerClass} ${classes.header} ${!expanded ? classes.headerCollapsed : ""}` },
                header,
                React.createElement(IconButton_1.default, { onClick: toggle, className: `${classes.expand} ${expanded ? classes.expandOpen : ""}`, "aria-expanded": expanded },
                    React.createElement(ExpandMore_1.default, null))),
            React.createElement(Collapse_1.default, { in: expanded, timeout: "auto", unmountOnExit: true }, children));
    }
    exports.FormCollapse = FormCollapse;
    function FormCollapseHeader(props) {
        return React.createElement(HGroup_1.HGroup, null,
            React.createElement("span", { style: props.style, className: `${(props.className ? props.className : "")}` }, props.label),
            "\u00A0",
            props.tooltip
                ? React.createElement(Tooltip_1.default, { id: `tt-${typeof props.label == "string" ? props.label : (0, MathUtil_1.random)()}`, text: props.tooltip })
                : null);
    }
    exports.FormCollapseHeader = FormCollapseHeader;
    function FormNoCollapse(props) {
        const { header, headerClass } = props;
        const classes = useStyles({});
        return React.createElement("div", { className: classes.root },
            React.createElement(HGroup_1.HGroup, { className: `${headerClass} ${classes.header} ${classes.headerCollapsed}` }, header));
    }
    exports.FormNoCollapse = FormNoCollapse;
});
